import React from 'react'

type IconProps = {
    className?: string
}

export const OrdersIcon: React.FC<IconProps> = ({ className }) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M6 3.33333H4.66667C4.31304 3.33333 3.9739 3.47381 3.72386 3.72386C3.47381 3.97391 3.33333 4.31304 3.33333 4.66667V12.6667C3.33333 13.0203 3.47381 13.3594 3.72386 13.6095C3.9739 13.8595 4.31304 14 4.66667 14H11.3333C11.687 14 12.0261 13.8595 12.2761 13.6095C12.5262 13.3594 12.6667 13.0203 12.6667 12.6667V4.66667C12.6667 4.31304 12.5262 3.97391 12.2761 3.72386C12.0261 3.47381 11.687 3.33333 11.3333 3.33333H10M6 3.33333C6 2.97971 6.14047 2.64057 6.39052 2.39052C6.64057 2.14048 6.97971 2 7.33333 2H8.66667C9.02029 2 9.35943 2.14048 9.60947 2.39052C9.85952 2.64057 10 2.97971 10 3.33333M6 3.33333C6 3.68696 6.14047 4.02609 6.39052 4.27614C6.64057 4.52619 6.97971 4.66667 7.33333 4.66667H8.66667C9.02029 4.66667 9.35943 4.52619 9.60947 4.27614C9.85952 4.02609 10 3.68696 10 3.33333M6 9.33333L7.33333 10.6667L10 8"
            stroke="#3E5060"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
